import { Box3, Matrix4 } from 'three/webgpu'

const inverse = new Matrix4()
const relative = new Matrix4()

export default function localBounds(object, target = new Box3()) {
	const piece = new Box3()

	object.updateWorldMatrix(true, true)
	inverse.copy(object.matrixWorld).invert()
	target.makeEmpty()

	object.traverse(child => {
		if (!child.isMesh) return

		child.geometry.computeBoundingBox()
		relative.multiplyMatrices(inverse, child.matrixWorld)
		target.union(piece.copy(child.geometry.boundingBox).applyMatrix4(relative))
	})

	return target
}
